import { CandidateList } from 'pages/common/CandidateList';
import React from 'react';

export const Candidates: React.FC<any> = () => {
  return <CandidateList />;
};
